import { Box, Button, Chip, Grid, Typography, Stack, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Divider, CircularProgress, LinearProgress } from "@mui/material"
import { useEffect, useMemo, useState, useCallback, useRef } from "react"
import { useForm } from "react-hook-form"
import { FormProvider, RHFRadioGroup, RHFSelectField, RHFTextField } from "../../../common/hook-form"
import Loader from "../../../common/Loader"
import { useDispatch, useSelector } from 'react-redux';
import { formatCurrency, getTotalUnitsOfOrder, maskAddress, parseDateAndTime, shouldMaskDataPD } from "../../../helpers/UtilityHelper"
import withLayout from "../../../hocs/Layout"
import { useLazyGetPaginatedShipmentsQuery, useLazyGetShipmentDetailQuery, useGetNDRDataQuery } from "../../../redux/commonRTK"
import { syncOrder } from '../../../redux/actions/orderList/orderListAction';
import { exclude, ItemListModal } from './index';
import ProzoDataGrid, { lastPageRowCount, useFirstPageOnChange } from "../../../common/ProzoDataGrid";
import { Link } from 'react-router-dom'
import { OrderStatusWiseFilter, OrderStatusChips, orderStatusClause } from "./OrderStatusFilter";
import PageTitle from "../../../common/PageTitle"
import MUIModal from "../../../common/MUIModal"
import QcDetails from "./QcDetails"
import { LoadingButton } from "@mui/lab"
import { apiConstants, getGeneric, postGeneric } from "../../../common/constants"
import { useSnackbar } from "notistack"
import _ from 'lodash'
import { addDays, format, subDays } from "date-fns"
import { useGetCouriersQuery } from "../../../redux/commonRTKPersist"
import { getMerchant, getToken } from "../../../helpers/ReduxHelpers"
import jwt_decode from "jwt-decode"
import CloneWithEditModal from "./CloneWithEditModal"
import ClonedOrdersModal from "./ClonedOrdersModal"
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import SyncIcon from '@mui/icons-material/Sync'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import ListAltIcon from '@mui/icons-material/ListAlt'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import ScheduleIcon from '@mui/icons-material/Schedule'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ReplayIcon from '@mui/icons-material/Replay'
import RaiseClaimModal from "../../claims/RaiseClaimModal"
import { Tooltip } from "@mui/material"
import { filterBarSx, primaryBtnSx, secondaryBtnSx, btnRowSx, pageContainerSx } from '../../../styles/patterns'
import { primaryTextSx, secondaryTextSx, tertiaryTextSx, cellStackSx, getStatusChipSx, awbTextSx } from './cellStyles'
import AwbLinkCell from '../../../common/AwbLinkCell'
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography'
import { NAVY, SUBTLE, WHITE, BORDER, PRIMARY_BLUE, SUCCESS, ERROR, withOpacity } from '../../../styles/foundation/colors'
import useCourierServiceType from '../../../hooks/useCourierServiceType'
import { getOrderDateRangeInfo, OrderDateRangeNote } from './OrderDateRangeBanner'


const excludes = exclude + ",customerDetail";

// Same 6 status buckets as the Forward Shipments summary (list2/index.js) — kept identical
// so "RTO" or "In Transit" mean the same thing on both pages.
const SUMMARY_TABS = [
    { label: 'All', icon: <ListAltIcon />, color: PRIMARY_BLUE, statuses: null },
    { label: 'Delivery Failed', icon: <ErrorOutlineIcon />, color: ERROR, statuses: ['FAILED_DELIVERY'] },
    { label: 'Pickups', icon: <ScheduleIcon />, color: PRIMARY_BLUE, statuses: ['ORDER_PLACED', 'PICKUP_PENDING', 'OUT_FOR_PICKUP', 'PICKUP_FAILED', 'MANIFESTED', 'AWB_REGISTERED'] },
    { label: 'In Transit', icon: <LocalShippingOutlinedIcon />, color: '#ff9800', statuses: ['INTRANSIT', 'SHIPMENT_DELAYED', 'CONTACT_CUSTOMER_CARE', 'SHIPMENT_HELD', 'PICKED_UP', 'OUT_FOR_DELIVERY', 'REACHED_AT_DESTINATION', 'SHIPPED', 'MISSING'] },
    { label: 'Delivered', icon: <CheckCircleOutlineIcon />, color: SUCCESS, statuses: ['DELIVERED'] },
    { label: 'RTO', icon: <ReplayIcon />, color: ERROR, statuses: ['RTO_REQUESTED', 'RTO', 'RTO_INTRANSIT', 'RTO_CONTACT_CUSTOMER_CARE', 'RTO_SHIPMENT_DELAY', 'RTO_OUT_FOR_DELIVERY', 'RTO_FAILED', 'RTO_DELIVERED'] },
];


function ReverseOrders() {
    const merchant = getMerchant();
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0)
    const [itemModalData, setItemModalData] = useState();
    const [itemModal, setItemModal] = useState(false);
    const [formFilters, setFormFilters] = useState([]);
    // New filters applied: start again from the first page.
    useFirstPageOnChange(formFilters, setPage);
    const [activeTab, setActiveTab] = useState(0);
    const [isLoadingResync, setisLoadingResync] = useState(false);
    const [newCourier, setNewCourier] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [clone, setClone] = useState(false);
    const [id, setId] = useState();
    const [cloneWithEdit, setCloneWithEdit] = useState(false);
    const [cloneWithEditRow, setCloneWithEditRow] = useState(null);
    const [viewClones, setViewClones] = useState(false);
    const [viewClonesRef, setViewClonesRef] = useState(null);
    const [claimModalOpen, setClaimModalOpen] = useState(false);
    const [claimShipment, setClaimShipment] = useState(null);
    const [actionMenu, setActionMenu] = useState(null);
    const closeActionMenu = () => setActionMenu(null);
    const runFromMenu = (fn) => () => { fn?.(); closeActionMenu(); };

    const [selectedRows, setSelectedRows] = useState([]);
    const [bulkCloneRunning, setBulkCloneRunning] = useState(false);
    const [bulkCloneProgress, setBulkCloneProgress] = useState({ done: 0, total: 0, succeeded: 0, failed: [] });
    const bulkAbortRef = useRef(false);
    const [bulkResults, setBulkResults] = useState([]);
    const [bulkResultsOpen, setBulkResultsOpen] = useState(false);

    const deriveReverseLeg = (row) => {
        const s = row?.orderStatus || '';
        if (s.startsWith('RTO_')) return 'RTO';
        if (s.startsWith('RVP_')) return 'RVP';
        if (row?.is_reverse) return 'RVP';
        return 'RVP';
    };

    const handleOpenClaim = (row) => {
        setClaimShipment({ ...row, shipment_type: deriveReverseLeg(row) });
        setClaimModalOpen(true);
    };
    const handleCloseClaim = () => {
        setClaimModalOpen(false);
        setClaimShipment(null);
    };
    const isReverseClaimEligible = (row) => {
        if (!row) return false;
        if (row.claimId || row.claim_id || row.hasClaim) return false;
        const s = row.orderStatus;
        return s === 'RTO_DELIVERED' || s === 'DELIVERED' || s === 'EXCHANGE_DELIVERED';
    };
    const [courierData, setCourierData] = useState()
    const paymentMode = [{ label: "PREPAID", value: "PREPAID" }, { label: "COD", value: "COD" }]
    const [getShipmentDetail] = useLazyGetShipmentDetailQuery();
    const [resData, setResData] = useState([])
    const [isLoadingC, setIsLoadingC] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const { data: allCouriers } = useGetCouriersQuery()
    const { blendedData } = useSelector(state => state?.report);
    const { piiAccessAllow } = jwt_decode(getToken());
    const { getServiceType } = useCourierServiceType();

    const [getPaginatedShipments, { data, isLoading, isFetching }] = useLazyGetPaginatedShipmentsQuery()

    const methods = useForm({
        defaultValues: {
            reference: '',
            pickup_pincode: '',
            drop_pincode: '',
            awb: '',
            status: [],
            email: '',
            phone: '',
        }
    });
    const {
        handleSubmit,
        reset,
    } = methods;

    const methods2 = useForm({
        defaultValues: {
            payment_mode: '',
            courier_type: ''
        }
    });
    const {
        handleSubmit: submitClone,
        reset: resetClone,
        watch: watchClone,
        setValue: setValClone
    } = methods2;

    const defaultFilters = [
        { field: "orderSubStatus", operator: "ne", value: "UNPROCESSED" },
        { field: "orderType", operator: "eq", value: "REVERSE SHIPMENT" },
        { field: "shipmentType", operator: "eq", value: "B2C" },
        { field: "merchant.$id", operator: "eq", value: merchant?.id }
    ]

    // Tab-driven status filter combined with whatever the filter form applied — mirrors
    // the Forward Shipments summary bar's 6 buckets (list2/index.js), scoped to this page's
    // own reverse-shipment defaultFilters.
    const andFilters = useMemo(() => {
        const activeStatuses = SUMMARY_TABS[activeTab]?.statuses
        return activeStatuses ? [...formFilters, { field: "orderStatus", operator: "in", value: activeStatuses }] : formFilters
    }, [formFilters, activeTab])

    // Live counts for the summary bar — one countOnly query per bucket (6 explicit calls, not
    // a .map() over the hook, since React Hooks must be called the same way every render),
    // each scoped by this page's own defaultFilters so counts only ever reflect this
    // merchant's reverse shipments.
    //
    // Same 30-day awbRegisteredDate window the Forward Shipments summary bar applies to its
    // count queries (list2/index.js defaultAndFilters). Without it each bucket is an all-time
    // count over every reverse order of the merchant: on prod the "All" and "Delivered"
    // buckets took 4-7 minutes per page open for large merchants (Bewakoof 422 s / 398 s,
    // Neeman's 254 s / 226 s on 2026-10-19). The listing itself is unchanged — the window is
    // applied to the badge counts only, exactly as on the forward page.
    const countWindowStart = `Date('${format(subDays(new Date(), 30), 'yyyy-MM-dd')} 00:00:00')`
    const countWindowFilter = { field: "awbRegisteredDate", operator: "gte", value: countWindowStart }
    const countQueryFor = (statuses) => ({
        andfilter: statuses
            ? [...defaultFilters, countWindowFilter, { field: "orderStatus", operator: "in", value: statuses }]
            : [...defaultFilters, countWindowFilter],
        sort: { field: "awbRegisteredDate", direction: "DESC" },
        offset: 0, limit: 1, includes: "id", countOnly: true,
    })
    const { data: allCount, isFetching: allLoading } = useGetNDRDataQuery(countQueryFor(SUMMARY_TABS[0].statuses))
    const { data: deliveryFailedCount, isFetching: deliveryFailedLoading } = useGetNDRDataQuery(countQueryFor(SUMMARY_TABS[1].statuses))
    const { data: pickupsCount, isFetching: pickupsLoading } = useGetNDRDataQuery(countQueryFor(SUMMARY_TABS[2].statuses))
    const { data: inTransitCount, isFetching: inTransitLoading } = useGetNDRDataQuery(countQueryFor(SUMMARY_TABS[3].statuses))
    const { data: deliveredCount, isFetching: deliveredLoading } = useGetNDRDataQuery(countQueryFor(SUMMARY_TABS[4].statuses))
    const { data: rtoCount, isFetching: rtoLoading } = useGetNDRDataQuery(countQueryFor(SUMMARY_TABS[5].statuses))
    const summaryTabs = SUMMARY_TABS.map((t, i) => ({
        ...t,
        count: [allCount, deliveryFailedCount, pickupsCount, inTransitCount, deliveredCount, rtoCount][i]?.count,
        loading: [allLoading, deliveryFailedLoading, pickupsLoading, inTransitLoading, deliveredLoading, rtoLoading][i],
    }))

    useEffect(() => {
        if (data?.count && data?.data) {
            setTotalRows(data.count)
        }
    }, [data])

    useEffect(() => {
        if (id && clone) {
            getShipmentDetail({
                "excludes": "sla,mongoLabelSignedUrlDetails,orderManifest,courierPricing,mongoInvoiceSignedUrlDetails,courierDetail,courier,courierId,merchant,merchantPricing,order_history", andfilter: [{ "field": "awbNumber", "operator": "eq", "value": id }], "offset": 0, "limit": 1
            }).then((res) => {
                let data = res.data.data[0]
                setResData(data)
                setValClone("payment_mode", data.payment_mode)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, clone])


    useEffect(() => {
        setPage(0)
    }, [sizePerPage])

    useEffect(() => {
        getPaginatedShipments({
            offset: (page * sizePerPage),
            limit: sizePerPage,
            andfilter: [...defaultFilters, ...andFilters],
            excludes,
            "skipCount": true,
            "sort": { "field": "awbRegisteredDate", "direction": "DESC" },
        })
        // eslint-disable-next-line
    }, [page, andFilters])

    const courierSelection = watchClone('courier_type')

    const applyFilters = (filters) => {
        let appliedFilters = [];
        const statusClause = orderStatusClause(filters.status);
        if (statusClause) {
            appliedFilters.push(statusClause)
        }
        if (filters.reference) {
            appliedFilters.push({ "field": "reference", "operator": "eq", "value": filters.reference })
        }

        if (filters.pickup_pincode) {
            appliedFilters.push({ "field": "pickupDetails.from_pincode", "operator": "eq", "value": filters.pickup_pincode })
        }

        if (filters.drop_pincode) {
            appliedFilters.push({ "field": "deliveryDetails.to_pincode", "operator": "eq", "value": filters.drop_pincode })
        }
        if (filters.awb) {
            appliedFilters.push({ "field": "awbNumber", "operator": "eq", "value": filters.awb })
        }
        if (filters.email) {
            appliedFilters.push({ "field": "pickupDetails.from_email", "operator": "eq", "value": filters.email })
        }
        if (filters.phone) {
            appliedFilters.push({ "field": "pickupDetails.from_phone_number", "operator": "eq", "value": filters.phone })
        }

        setFormFilters(appliedFilters)
    }


    const handleSync = (awbNumber, reference) => {
        if (awbNumber) {
            setisLoadingResync(true)
            dispatch(syncOrder({ waybill: awbNumber, reference: reference })).finally(() => setisLoadingResync(false))
        }
    }
    const { report } = useSelector(state => state);

    const handleClickClone = (row, data) => {
        setCourierData(data)
        setClone(true);
        setId(row);
    };

    const columns = [
        {
            field: 'actions', headerAlign: "center", hideSortIcons: true, headerName: 'Order Details', flex: 1.3, minWidth: 150, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.reference}</Typography>
                        {row.shippingLabelId && row.reference !== row.shippingLabelId && (
                            <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
                        )}
                        <Typography sx={secondaryTextSx}>
                            {(row.createdDate) ? parseDateAndTime(row.createdDate) : ""}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'courier', headerAlign: "center", hideSortIcons: true, headerName: 'Courier Partner', flex: 1.1, minWidth: 140, renderCell: (params) => {
                const { row } = params;
                const serviceType = getServiceType(row.courierDetail?.prozoId);
                return (
                    <Box sx={cellStackSx}>
                        {row.awb_number && (
                            <AwbLinkCell awb={row.awb_number} sx={awbTextSx} />
                        )}
                        <Typography sx={secondaryTextSx}>{row?.courierDetail?.parent || ''}</Typography>
                        {serviceType && <Typography sx={tertiaryTextSx}>{serviceType}</Typography>}
                    </Box>
                )
            },
        },
        {
            field: 'delivery', headerAlign: "center", hideSortIcons: true, headerName: 'Delivery Details', flex: 1.3, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                const pickupName = row.pickup_details?.from_name || '-NA-';
                const pickupPincode = row.pickup_details?.from_pincode
                    ? (shouldMaskDataPD(report, row, piiAccessAllow) ? maskAddress(row.pickup_details.from_pincode) : row.pickup_details.from_pincode)
                    : '-NA-';
                const deliveryName = row.delivery_details?.to_name || '';
                const deliveryPincode = row.delivery_details?.to_pincode || '-NA-';
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>Pickup: {pickupName}, {pickupPincode}</Typography>
                        <Typography sx={secondaryTextSx}>Delivery: {deliveryName}, {deliveryPincode}</Typography>
                    </Box>
                )
            },
        },
        {
            field: 'shipment', headerAlign: "center", hideSortIcons: true, headerName: 'Package Details', flex: 1.3, minWidth: 130, renderCell: (params) => {
                const { row } = params;
                const detail = row.shipment_detail?.[0];
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}>
                            DW: {detail ? `${(detail.item_weight / 1000).toFixed(2)} kg` : '-'}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            VW: {detail ? `${((detail.item_length * detail.item_breadth * detail.item_height) / 5000).toFixed(2)} kg` : '-'}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {detail ? `${detail.item_length} x ${detail.item_breadth} x ${detail.item_height} cm` : '-'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'itemDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Item Details', flex: 0.8, minWidth: 90, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Button onClick={() => { setItemModal(true); setItemModalData(row.item_list) }}
                            sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0, justifyContent: 'flex-start' }}>
                            View Items
                        </Button>
                        <Typography sx={secondaryTextSx}>{getTotalUnitsOfOrder(row.item_list)} units</Typography>
                    </Box>
                )
            },
        },
        {
            field: 'paymentDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Invoice Amt', flex: 0.8, minWidth: 100, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>
                            {row.invoice_value ? formatCurrency(row.invoice_value) : '-'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'statusDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Status', flex: 1, minWidth: 130, renderCell: (params) => {
                const { row } = params;
                return (<Chip size="small" label={row.orderStatus} sx={getStatusChipSx(row.orderStatus)} />)
            },
        },
        {
            field: 'qcDetails', headerAlign: "center", hideSortIcons: true, headerName: 'QC Details', flex: 0.7, minWidth: 80, renderCell: (params) => {
                const { row } = params;
                if (row.qcDetails) {
                    return (
                        <Button onClick={() => handleOpen(row)}
                            sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0 }}>
                            View
                        </Button>
                    )
                }
                return <Typography sx={secondaryTextSx}>-</Typography>
            },
        },
        {
            field: 'action', headerAlign: "center", hideSortIcons: true, headerName: 'Action', flex: 1.1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                return (
                    <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
                        <Button
                            variant="contained" size="small"
                            component={Link} to={`/order-detail?waybill=${row.awb_number}`}
                            target="_blank" rel="noopener noreferrer"
                            sx={{ whiteSpace: 'nowrap', textTransform: 'none', fontWeight: 600, px: 2, fontSize: 12 }}>
                            Details
                        </Button>
                        <Tooltip title="More actions">
                            <IconButton
                                size="small"
                                onClick={(e) => setActionMenu({ anchorEl: e.currentTarget, row })}
                                sx={{
                                    bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider',
                                    borderRadius: 1, width: 32, height: 32, '&:hover': { bgcolor: 'grey.100' },
                                }}>
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                )
            },
        },
    ];
    const [row, setRow] = useState();
    const [viewQc, setViewQc] = useState(false)
    const handleOpen = (row) => {
        setViewQc(true)
        setRow(row)
    }
    const handleClose = () => {
        setViewQc(false)
    }
    const cloneOrder = (fill) => {
        setIsSubmitting(true)
        let newData = {}
        newData.order_type = resData.order_type;
        newData.order_date = new Date();
        newData.item_list = resData.item_list;
        newData.pickup_details = resData.pickup_details;
        newData.delivery_details = resData.delivery_details;
        newData.shipment_type = resData.shipment_type;
        newData.customer_detail = resData.customer_detail;
        newData.shipment_detail = resData.shipment_detail;
        newData.invoice_value = resData.invoice_value;
        newData.is_reverse = true;
        newData.rvp_reason = resData.rvp_reason;
        newData.payment_mode = fill.payment_mode;
        newData.cod_amount = fill.payment_mode === "PREPAID" ? 0 : resData.invoice_value;
        newData.client_order_id = resData.client_order_id;
        newData.invoice_number = resData.invoice_number;
        newData.shipping_charge = resData.shipping_charge;
        newData.transaction_charge = resData.transaction_charge;
        newData.giftwrap_charge = resData.giftwrap_charge;
        newData.shippingLabelId = resData.shippingLabelId;
        newData.reference = 'c' + resData.reference;
        newData.channelOrderUniqueKey = resData.channelOrderUniqueKey;
        newData.dispatch_mode = resData.dispatch_mode;
        newData.skipRule = fill.courier_type === "Other" ? true : false;
        newData.merchantOId = merchant?.id
        newData.clonedOrderReference = resData.reference;

        if (fill.courier_type !== "Other") {
            delete newData.courierPartner;
        } else {
            newData.courier_id = {
                prozoId: fill.courierPartner
            };
            delete newData.courierPartner;
        }
        try {
            postGeneric(apiConstants.CLONE_ORDER, newData).then((res) => {
                if (res.status === 200) {
                    enqueueSnackbar(res?.data?.meta?.message || "Order cloned successfully", { variant: "success" });
                    setClone(() => false)
                    setIsSubmitting(false)
                }
            }).catch((err) => {
                console.log(err);
                enqueueSnackbar("Something went wrong while cloning the order", { variant: "error" })
                setIsSubmitting(false)
                setClone(() => false)
            }).finally(() => resetClone())
        } catch (err) {
            enqueueSnackbar("Something went wrong while cloning the order", { variant: "error" });
            setClone(() => false)
            setIsSubmitting(false)
        }
    };


    const BATCH_SIZE = 3;
    const BATCH_DELAY_MS = 500;

    const fetchOrderDetail = useCallback(async (awbNumber) => {
        const res = await postGeneric(apiConstants.ORDER_LISTS, {
            excludes: "sla,mongoLabelSignedUrlDetails,orderManifest,courierPricing,mongoInvoiceSignedUrlDetails,courierDetail,courier,courierId,merchant,merchantPricing,order_history",
            andfilter: [{ field: "awbNumber", operator: "eq", value: awbNumber }],
            offset: 0,
            limit: 1,
        });
        return res?.data?.data?.[0];
    }, []);

    const buildClonePayload = useCallback((orderData) => {
        return {
            order_type: orderData.order_type,
            order_date: new Date(),
            item_list: orderData.item_list,
            pickup_details: orderData.pickup_details,
            delivery_details: orderData.delivery_details,
            shipment_type: orderData.shipment_type,
            customer_detail: orderData.customer_detail,
            shipment_detail: orderData.shipment_detail,
            invoice_value: orderData.invoice_value,
            is_reverse: true,
            rvp_reason: orderData.rvp_reason,
            payment_mode: orderData.payment_mode,
            cod_amount: orderData.payment_mode === "PREPAID" ? 0 : orderData.invoice_value,
            client_order_id: orderData.client_order_id,
            invoice_number: orderData.invoice_number,
            shipping_charge: orderData.shipping_charge,
            transaction_charge: orderData.transaction_charge,
            giftwrap_charge: orderData.giftwrap_charge,
            shippingLabelId: orderData.shippingLabelId,
            reference: 'c' + orderData.reference,
            channelOrderUniqueKey: orderData.channelOrderUniqueKey,
            dispatch_mode: orderData.dispatch_mode,
            qc_type: orderData.qc_type,
            channel_name: orderData.channel_name,
            skipRule: false,
            merchantOId: merchant?.id,
            clonedOrderReference: orderData.reference,
        };
    }, [merchant?.id]);

    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    const handleBulkClone = useCallback(async () => {
        const orders = selectedRows.filter((r) => r.awb_number);
        if (!orders.length) return;

        bulkAbortRef.current = false;
        setBulkCloneRunning(true);
        setBulkCloneProgress({ done: 0, total: orders.length, succeeded: 0, failed: [] });

        let succeeded = 0;
        const failed = [];
        const results = [];

        for (let i = 0; i < orders.length; i += BATCH_SIZE) {
            if (bulkAbortRef.current) break;

            const batch = orders.slice(i, i + BATCH_SIZE);

            const settled = await Promise.allSettled(
                batch.map(async (row) => {
                    const detail = await fetchOrderDetail(row.awb_number);
                    if (!detail) throw new Error('Order details not found');
                    const payload = buildClonePayload(detail);
                    const res = await postGeneric(apiConstants.CLONE_ORDER_WITH_EDIT, payload);
                    return { row, res };
                })
            );

            settled.forEach((s, idx) => {
                const awb = batch[idx].awb_number;
                const ref = batch[idx].reference || awb;
                if (s.status === 'fulfilled') {
                    succeeded++;
                    const newAwb = s.value?.res?.data?.data?.awb_number || s.value?.res?.data?.data?.awbNumber || '';
                    const newRef = s.value?.res?.data?.data?.reference || '';
                    results.push({ awb, reference: ref, status: 'success', newAwb, newRef, message: s.value?.res?.data?.meta?.message || 'Cloned successfully' });
                } else {
                    failed.push(awb);
                    const errMsg = s.reason?.response?.data?.message || s.reason?.message || 'Unknown error';
                    results.push({ awb, reference: ref, status: 'error', message: errMsg });
                }
            });

            setBulkCloneProgress({ done: Math.min(i + BATCH_SIZE, orders.length), total: orders.length, succeeded, failed: [...failed] });

            if (i + BATCH_SIZE < orders.length && !bulkAbortRef.current) {
                await sleep(BATCH_DELAY_MS);
            }
        }

        setBulkCloneRunning(false);
        setSelectedRows([]);
        setBulkResults(results);
        setBulkResultsOpen(true);

        getPaginatedShipments({
            offset: page * sizePerPage,
            limit: sizePerPage,
            andfilter: [...defaultFilters, ...andFilters],
            excludes,
            skipCount: true,
            sort: { field: "awbRegisteredDate", direction: "DESC" },
        });
    }, [selectedRows, fetchOrderDetail, buildClonePayload, getPaginatedShipments, page, sizePerPage, defaultFilters, andFilters]);

    const callShipmentRateCalculator = (pincodeResponse) => {
        console.log(pincodeResponse, 'Pincode Response');
        const pickup_details = {
            from_address: courierData?.pickup_details?.address_line,
            from_city: courierData?.pickup_details?.city,
            from_country: courierData?.pickup_details?.country,
            from_name: courierData?.pickup_details?.name,
            from_pincode: pincodeResponse?.pickupPincode,
            from_state: courierData?.pickup_details?.state,
            from_phone_number: courierData?.pickup_details?.contactNumber,
            from_email: courierData?.pickup_details?.email,
            gstin: courierData?.pickup_details?.gstin
        }

        let length = _.sumBy(courierData?.shipment_detail, "item_length")
        let breadth = _.sumBy(courierData?.shipment_detail, "item_breadth")
        let height = _.sumBy(courierData?.shipment_detail, "item_height")
        let weight = _.sumBy(courierData?.shipment_detail, "item_weight")
        if (pickup_details) {
            postGeneric(`${apiConstants.SHIPMENT_RATE_CALCULATOR}`, {
                orderType: "RVP",
                to: parseInt(pincodeResponse?.deliveryPincode),
                from: parseInt(pickup_details?.from_pincode),
                paymentType: courierData?.payment_mode.toLowerCase() === "prepaid" ? "PREPAID" : "COD",
                "length": length,
                "breadth": breadth,
                "height": height,
                "weight": weight,
                "dispatchMode": "SURFACE",
                "codAmount": Number(courierData.cod_amount) || 0,
                "isMerchant": true,
                onlyCouriersAsPerRuleMapping: true, checkServiceable: true,
                merchantOid: merchant?.id

            }).then((res) => {
                setIsLoadingC(false)
                const pricing = res?.data;
                const newCourier = allCouriers?.map((d) => {
                    const updatedCourier = { ...d };
                    pricing.forEach((t) => {
                        if (t.provider?.id === updatedCourier.prozoId) {
                            updatedCourier.priceAfterTax = t.priceAfterTax;
                            updatedCourier.providerMinTatDays = t.providerMinTatDays;
                            updatedCourier.providerMaxTatDays = t.providerMaxTatDays;
                        }
                    });
                    return updatedCourier;
                })
                let filteredCouriers = newCourier.filter(item =>
                    item.priceAfterTax &&
                    item.type === 'RVP'
                )
                const now = new Date();
                filteredCouriers.forEach(shipment => {
                    let minTatDays = shipment.providerMinTatDays || 0;
                    let maxTatDays = shipment.providerMaxTatDays || 0;
                    shipment.minDeliveryDate = format(addDays(now, minTatDays), 'dd, MMM');
                    shipment.maxDeliveryDate = format(addDays(now, maxTatDays), 'dd, MMM');
                });
                setNewCourier(filteredCouriers);
            }).catch((err) => {
                console.log(err)
                enqueueSnackbar(err?.response?.data?.message || "Something went wrong", { variant: "error" });
                setIsLoadingC(false)
            })
        }
    }

    useEffect(() => {
        if (courierData && courierSelection === "Other") {
            setIsLoadingC(true)
            getGeneric(`${apiConstants.GET_PINCODES}?merchantOid=${merchant?.id}&awbNumber=${courierData?.awb_number}`)
                .then((res) => {
                    console.log('Pincode response:', res?.data);
                    callShipmentRateCalculator(res?.data);
                })
                .catch((err) => {
                    console.log('Error fetching pincodes:', err);
                    enqueueSnackbar("Error fetching pincode data", { variant: "error" });
                    setIsLoadingC(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [courierSelection, courierData])


    const renderActionMenu = () => {
        const menuRow = actionMenu?.row;
        if (!menuRow) return null;
        const showClaimRow = menuRow?.orderStatus === 'RTO_DELIVERED' || menuRow?.orderStatus === 'DELIVERED' || menuRow?.orderStatus === 'EXCHANGE_DELIVERED';
        const menuPaperSx = { minWidth: 200, '& .MuiMenuItem-root': { fontSize: 12, py: 0.75 }, '& .MuiListItemText-primary': { fontSize: 12 }, '& .MuiListItemIcon-root': { minWidth: 28 } };
        return (
            <Menu anchorEl={actionMenu?.anchorEl} open={Boolean(actionMenu)} onClose={closeActionMenu} PaperProps={{ sx: menuPaperSx }}>
                <MenuItem onClick={runFromMenu(() => { setCloneWithEditRow(menuRow); setCloneWithEdit(true); })}>
                    <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>Clone</ListItemText>
                </MenuItem>
                <MenuItem onClick={runFromMenu(() => handleSync(menuRow.awb_number, menuRow.reference))}>
                    <ListItemIcon><SyncIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>Resync</ListItemText>
                </MenuItem>
                <MenuItem onClick={runFromMenu(() => { setViewClonesRef(menuRow.reference); setViewClones(true); })}>
                    <ListItemIcon><VisibilityOutlinedIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>View Clones</ListItemText>
                </MenuItem>
                {showClaimRow && <Divider />}
                {showClaimRow && (menuRow?.claimId || menuRow?.claim_id) && (
                    <MenuItem component={Link} to={`/claims/${menuRow.claimId || menuRow.claim_id}`} onClick={closeActionMenu}>
                        <ListItemIcon><GavelOutlinedIcon fontSize="small" sx={{ color: 'success.main' }} /></ListItemIcon>
                        <ListItemText>Claim Raised</ListItemText>
                    </MenuItem>
                )}
                {showClaimRow && !(menuRow?.claimId || menuRow?.claim_id) && !menuRow?.claimWindowExpired && isReverseClaimEligible(menuRow) && (
                    <MenuItem onClick={runFromMenu(() => handleOpenClaim(menuRow))}>
                        <ListItemIcon><GavelOutlinedIcon fontSize="small" /></ListItemIcon>
                        <ListItemText>Raise Claim</ListItemText>
                    </MenuItem>
                )}
                {showClaimRow && !(menuRow?.claimId || menuRow?.claim_id) && menuRow?.claimWindowExpired && (
                    <MenuItem disabled>
                        <ListItemIcon><GavelOutlinedIcon fontSize="small" /></ListItemIcon>
                        <ListItemText>Claim Window Closed</ListItemText>
                    </MenuItem>
                )}
            </Menu>
        );
    };

    // "What date range is this page showing" — same helper the Forward Shipments page uses.
    // Reverse has no custom Created-Date filter, so it reflects the loaded orders' min/max date.
    const dateRangeInfo = getOrderDateRangeInfo(null, data?.data);

    return (
        <>
            {isLoadingResync && <Loader />}
            <MUIModal open={viewQc} handleClose={handleClose} children={<QcDetails data={row} />} title={"Qc Link"} maxWidth='sm' />
            <Box sx={pageContainerSx}>
                <PageTitle subTitle="Track and manage your reverse pickup shipments">RVP Shipments</PageTitle>

                {/* Same live-count summary bar as Forward Shipments (list2/index.js) — was
                   missing here entirely; clicking a tab quick-filters this page's single grid
                   by that status bucket instead of swapping to a separate component per tab. */}
                <Box sx={{ bgcolor: WHITE, border: `1px solid ${BORDER}`, borderRadius: '12px', mb: 2, overflow: 'hidden' }}>
                    <Box sx={{ display: 'flex' }}>
                        {summaryTabs.map((t, i) => {
                            const isTabActive = activeTab === i;
                            const countDisplay = t.count > 99999 ? '99,999+' : t.count?.toLocaleString?.() ?? '—';
                            return (
                                <Box key={t.label} sx={{ display: 'flex', flex: '1 1 auto' }}>
                                    {i > 0 && <Divider orientation="vertical" flexItem sx={{ borderColor: BORDER }} />}
                                    <Box
                                        onClick={() => { setActiveTab(i); setPage(0); }}
                                        sx={{
                                            flex: '1 1 auto', minWidth: 130, py: 1.25, px: 2, cursor: 'pointer',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                                            borderBottom: isTabActive ? `3px solid ${t.color}` : '3px solid transparent',
                                            bgcolor: isTabActive ? withOpacity(t.color, 0.06) : 'transparent',
                                            transition: 'all 0.15s',
                                            '&:hover': { bgcolor: withOpacity(t.color, 0.04) },
                                        }}
                                    >
                                        <Box sx={{
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            width: 30, height: 30, borderRadius: '8px',
                                            bgcolor: isTabActive ? withOpacity(t.color, 0.12) : withOpacity(t.color, 0.07),
                                            color: isTabActive ? t.color : SUBTLE,
                                            '& .MuiSvgIcon-root': { fontSize: 17 },
                                        }}>
                                            {t.icon}
                                        </Box>
                                        <Box>
                                            <Typography sx={{
                                                fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.medium,
                                                color: isTabActive ? NAVY : SUBTLE, lineHeight: 1.2,
                                            }}>
                                                {t.label}
                                            </Typography>
                                            {t.loading ? (
                                                <Box sx={{ display: 'flex', alignItems: 'center', height: 22 }}>
                                                    <CircularProgress size={15} thickness={5.5} sx={{ color: isTabActive ? t.color : SUBTLE }} />
                                                </Box>
                                            ) : (
                                                <Typography sx={{
                                                    fontFamily: FONT, fontSize: SIZE.sm, fontWeight: WEIGHT.bold,
                                                    color: isTabActive ? t.color : NAVY, lineHeight: 1.3,
                                                }}>
                                                    {countDisplay}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Box>
                            );
                        })}
                    </Box>
                    {/* The counts above are windowed (countWindowFilter); the grid below is not. */}
                    <Typography sx={{
                        fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE,
                        px: 2, py: 0.5, borderTop: `1px solid ${BORDER}`, textAlign: 'right',
                    }}>
                        Counts cover shipments created in the last 30 days
                    </Typography>
                </Box>

                <Box data-rp-filters sx={filterBarSx}>
                    <FormProvider methods={methods} onSubmit={handleSubmit(applyFilters)}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={6} md={2}>
                                <RHFTextField name="reference" label="Order/Reference No." />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <RHFTextField name="awb" label="AWB Number" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <RHFTextField name="pickup_pincode" label="Pickup Pincode" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <RHFTextField name="email" label="Pickup Email" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <RHFTextField name="phone" label="Pickup Phone" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <OrderStatusWiseFilter active={6} />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={btnRowSx}>
                                    <Button type="submit" variant="contained" sx={primaryBtnSx}>Filter</Button>
                                    <Button variant="outlined" sx={secondaryBtnSx} onClick={() => {
                                        reset()
                                        setFormFilters([])
                                        setActiveTab(0)
                                    }}>Reset</Button>
                                </Box>
                            </Grid>
                        </Grid>
                        <OrderStatusChips applied={formFilters.find((c) => c.field === 'orderStatus')?.value} onApply={applyFilters} />
                    </FormProvider>
                </Box>

                {/* Date details — shared readout (see OrderDateRangeNote). */}
                <OrderDateRangeNote dateRangeInfo={dateRangeInfo} />

                {selectedRows.length > 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5, px: 1 }}>
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.medium, color: NAVY }}>
                            {selectedRows.length} order{selectedRows.length > 1 ? 's' : ''} selected
                        </Typography>
                        <LoadingButton
                            loading={bulkCloneRunning}
                            variant="contained"
                            size="small"
                            startIcon={<ContentCopyIcon />}
                            sx={primaryBtnSx}
                            onClick={handleBulkClone}
                        >
                            Bulk Clone
                        </LoadingButton>
                        {bulkCloneRunning && (
                            <Button variant="outlined" size="small" sx={secondaryBtnSx} onClick={() => { bulkAbortRef.current = true; }}>
                                Cancel
                            </Button>
                        )}
                    </Box>
                )}

                {bulkCloneRunning && (
                    <Box sx={{ mb: 1.5, px: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                            <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE }}>
                                Cloning {bulkCloneProgress.done} of {bulkCloneProgress.total}
                                {bulkCloneProgress.failed.length > 0 && ` (${bulkCloneProgress.failed.length} failed)`}
                            </Typography>
                        </Box>
                        <LinearProgress
                            variant="determinate"
                            value={bulkCloneProgress.total ? (bulkCloneProgress.done / bulkCloneProgress.total) * 100 : 0}
                            sx={{ borderRadius: 4, height: 6 }}
                        />
                    </Box>
                )}

                <ProzoDataGrid
                    columns={columns}
                    hideFooterPagination={false}
                    autoHeight={true}
                    rows={data?.data || []}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                    setPage={setPage}
                    page={page}
                    hideCountNumber={true}
                    rowCount={lastPageRowCount({ page, pageSize: sizePerPage, rowsOnPage: data?.data?.length, loading: isFetching })}
                    pagination={true}
                    filterMode={"server"}
                    checkboxSelection={true}
                    rowSelectionModel={selectedRows.map((r) => r.id)}
                    setRowSelectionModel={(ids) => {
                        const rows = data?.data || [];
                        setSelectedRows(rows.filter((r) => ids.includes(r.id)));
                    }}
                    getRowId={(row) => row.id} />

                {(isLoading || isFetching) && <Loader />}
                <ItemListModal data={itemModalData} itemModal={itemModal} setItemModal={setItemModal} />
                <MUIModal
                    maxWidth="lg"
                    open={clone}
                    handleClose={() => { setClone(false); resetClone() }}
                    title={"Are you sure you want to clone this order?"}
                    hideClose={true}
                >
                    <FormProvider methods={methods2} onSubmit={submitClone(cloneOrder)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ mt: 1 }}>
                                <RHFSelectField name='payment_mode' width={"100%"} label='Payment Mode' options={paymentMode.map((val) => ({
                                    value: val.value,
                                    label: val.label
                                }))} />
                            </Grid>
                            {blendedData ?

                                <Grid item xs={12} sx={{ mt: 1, ml: 1 }}>
                                    <RHFRadioGroup label="Courier Selection" name="courier_type" options={[
                                        {
                                            label: "As per Recommendation Rules",
                                            value: "Prozo Choice",
                                        },
                                    ]}

                                    />
                                </Grid> :
                                <Grid item xs={12} sx={{ mt: 1, ml: 1 }}>
                                    <RHFRadioGroup label="Courier Selection" name="courier_type" options={[
                                        {
                                            label: "As per Recommendation Rules",
                                            value: "Prozo Choice",
                                        },
                                        { label: "Other Courier", value: "Other" },
                                    ]}

                                    />
                                </Grid>
                            }
                            {isLoadingC ? <Loader /> :
                                <>
                                    {courierSelection === 'Other' && (
                                        <Grid item xs={12}>
                                            <RHFSelectField
                                                width="100%"
                                                name="courierPartner"
                                                label="Courier Partner"
                                                noOptionsText='No courier partner available for this pickup location'
                                                options={(newCourier)?.filter(row => !row.isExternal).map((c) => {
                                                    return {
                                                        label: <Grid container spacing={0}>
                                                            <Grid item xs={4}>
                                                                <Typography variant="body2">{c?.name}</Typography>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Typography variant="body2">{formatCurrency(c?.priceAfterTax)}</Typography>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                <Typography variant="body2">
                                                                    {c.providerMinTatDays !== undefined && c.providerMaxTatDays !== undefined && c.providerMaxTatDays > 0 ?
                                                                        `TAT: ${c.providerMinTatDays}-${c.providerMaxTatDays} Days` :
                                                                        'TAT: Not Available'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                <Typography variant="body2">
                                                                    {c.providerMinTatDays !== undefined && c.providerMaxTatDays !== undefined && c.providerMaxTatDays > 0 ?
                                                                        `EDD: ${c.minDeliveryDate}-${c.maxDeliveryDate}` :
                                                                        'EDD: Not Available'}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>,
                                                        value: c?.prozoId
                                                    };
                                                })}
                                            />
                                        </Grid>
                                    )}
                                </>
                            }
                            <Grid item xs={12} sx={{ display: "flex", justifyContent: 'center', p: 2 }}>
                                <Button variant="outlined" sx={secondaryBtnSx} onClick={() => setClone(false)}>No</Button>
                                <LoadingButton loading={isSubmitting} variant="contained" type='submit' sx={{ ...primaryBtnSx, ml: 1 }}>YES</LoadingButton>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </MUIModal>
            </Box>
            <CloneWithEditModal
                open={cloneWithEdit}
                onClose={() => { setCloneWithEdit(false); setCloneWithEditRow(null); }}
                orderId={cloneWithEditRow?.awb_number}
                orderData={cloneWithEditRow}
                merchantId={merchant?.id}
                onSuccess={() => getPaginatedShipments({
                    offset: page * sizePerPage,
                    limit: sizePerPage,
                    andfilter: [...defaultFilters, ...andFilters],
                    excludes,
                    skipCount: true,
                    sort: { field: "awbRegisteredDate", direction: "DESC" },
                })}
            />
            <ClonedOrdersModal
                open={viewClones}
                onClose={() => { setViewClones(false); setViewClonesRef(null); }}
                reference={viewClonesRef}
                defaultFilters={defaultFilters}
            />
            <RaiseClaimModal
                open={claimModalOpen}
                onClose={handleCloseClaim}
                shipment={claimShipment}
                merchantId={merchant?.id}
                onSuccess={() => {
                    getPaginatedShipments({
                        offset: page * sizePerPage,
                        limit: sizePerPage,
                        andfilter: [...defaultFilters, ...andFilters],
                        excludes,
                        skipCount: true,
                        sort: { field: "awbRegisteredDate", direction: "DESC" },
                    });
                }}
            />
            {renderActionMenu()}
            <MUIModal
                open={bulkResultsOpen}
                handleClose={() => setBulkResultsOpen(false)}
                title="Bulk Clone Results"
                maxWidth="md"
            >
                <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
                    <Box sx={{
                        px: 2, py: 1, borderRadius: '8px', bgcolor: '#dcfce7', border: '1px solid #bbf7d0',
                        display: 'flex', alignItems: 'center', gap: 1,
                    }}>
                        <CheckCircleOutlineIcon sx={{ fontSize: 18, color: '#15803d' }} />
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: '#15803d' }}>
                            {bulkResults.filter((r) => r.status === 'success').length} Successful
                        </Typography>
                    </Box>
                    <Box sx={{
                        px: 2, py: 1, borderRadius: '8px', bgcolor: '#fef2f2', border: '1px solid #fecaca',
                        display: 'flex', alignItems: 'center', gap: 1,
                    }}>
                        <ErrorOutlineIcon sx={{ fontSize: 18, color: '#dc2626' }} />
                        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: '#dc2626' }}>
                            {bulkResults.filter((r) => r.status === 'error').length} Failed
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
                    {bulkResults.map((r, i) => (
                        <Box key={i} sx={{
                            display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1.5, px: 1.5,
                            borderBottom: i < bulkResults.length - 1 ? '1px solid #f3f4f6' : 'none',
                            bgcolor: r.status === 'error' ? '#fef2f2' : 'transparent',
                            borderRadius: '6px', mb: 0.5,
                        }}>
                            {r.status === 'success'
                                ? <CheckCircleOutlineIcon sx={{ fontSize: 20, color: '#16a34a', mt: 0.25 }} />
                                : <ErrorOutlineIcon sx={{ fontSize: 20, color: '#dc2626', mt: 0.25 }} />
                            }
                            <Box sx={{ flex: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: NAVY }}>
                                        {r.reference}
                                    </Typography>
                                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE }}>
                                        AWB: {r.awb}
                                    </Typography>
                                </Box>
                                {r.status === 'success' && (
                                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: '#15803d', mt: 0.25 }}>
                                        {r.message}{r.newAwb ? ` — New AWB: ${r.newAwb}` : ''}
                                    </Typography>
                                )}
                                {r.status === 'error' && (
                                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: '#dc2626', mt: 0.25 }}>
                                        {r.message}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </MUIModal>
        </>
    )
}
export default withLayout(ReverseOrders)
